import type { ReactNode } from 'react';

type Tone = 'success' | 'warning' | 'error' | 'info';

const toneClass: Record<Tone, string> = {
  success: 'border-green-200 bg-green-50 text-green-800',
  warning: 'border-amber-200 bg-amber-50 text-amber-800',
  error: 'border-red-200 bg-red-50 text-red-700',
  info: 'border-gray-200 bg-gray-50 text-gray-700',
};

export const Notice = ({ tone = 'info', children }: { tone?: Tone; children: ReactNode }) => (
  <div role={tone === 'error' ? 'alert' : 'status'} className={`rounded-lg border px-4 py-3 text-sm ${toneClass[tone]}`}>
    {children}
  </div>
);
